<template>
  <h1>Differences</h1>
</template>